import firebase from 'firebase';
import { parseBoolFromString } from '../helper/helpers.js';
// import { customStateMethods } from '@/state/helpers';
import axios from 'axios';
import store from '@/state/store.js';

export function getCustomers() {
  return firebase
    .firestore()
    .collection('customers')
    .where('org', '==', sessionStorage.getItem('org'))
    .orderBy('customerName', 'asc')
    .get();
}

export function getEmployees() {
  return firebase
    .firestore()
    .collection('employees')
    .where('org', '==', sessionStorage.getItem('org'))
    .where('deactivatedDate', '==', null)
    .orderBy('name', 'asc')
    .get();
}

export function getAllEmployees() {
  return firebase
    .firestore()
    .collection('employees')
    .where('org', '==', sessionStorage.getItem('org'))
    .orderBy('name', 'asc')
    .get();
}

export function getProducts() {
  return firebase
    .firestore()
    .collection('products')
    .where('org', '==', sessionStorage.getItem('org'))
    .orderBy('name', 'asc')
    .get();
}

export function getUnits() {
  return firebase
    .firestore()
    .collection('units')
    .where('org', '==', sessionStorage.getItem('org'))
    .orderBy('name', 'asc')
    .get();
}
// add lastUpdated + lastUpdatedBy to a work order repairs write (only use on repairs writes)
export function withLastUpdated(payload) {
  const u = (store && store.state && store.state.custom && store.state.custom.currentUserData) || {};
  return {
    ...payload,
    lastUpdated: firebase.firestore.FieldValue.serverTimestamp(),
    lastUpdatedBy: { uid: u.uid || null, name: u.displayName || u.name || null },
  };
}

// re-read the WO and report if it's safe to write (and who last changed it)
export async function checkWoFreshness(workOrderID, localLastPull, currentUid) {
  const snap = await firebase
    .firestore()
    .collection('workOrders')
    .doc(workOrderID)
    .get();
  const data = snap.data() || {};
  const lastUpdated =
    data.lastUpdated && typeof data.lastUpdated.toMillis === 'function'
      ? data.lastUpdated.toMillis()
      : 0;
  const updatedByMe = !!(data.lastUpdatedBy && data.lastUpdatedBy.uid === currentUid);
  return {
    fresh: lastUpdated <= localLastPull || updatedByMe,
    lastUpdatedBy: data.lastUpdatedBy || null,
  };
}

// fetch one work order doc by id
export function getWorkOrderById(workOrderID) {
  return firebase
    .firestore()
    .collection('workOrders')
    .doc(workOrderID)
    .get();
}

// shape a raw workOrders doc into board/modal form (shared by board load + fresh fetch; mutates rawData)
export function hydrateWorkOrderDoc(rawData, docId, units, repairHoursEnabled, repairCostEnabled, labourHoursEnabled) {
  const wo = rawData || {};
  const TS = firebase.firestore.Timestamp;

  // default repairHours/repairCost/labourHours when enabled
  if (Array.isArray(wo.repairs) && (repairHoursEnabled || repairCostEnabled || labourHoursEnabled)) {
    wo.repairs.forEach((repair) => {
      if (repairHoursEnabled && repair['repairHours'] == undefined) {
        repair.repairHours = null;
      }
      if (repairCostEnabled && repair['repairCost'] == undefined) {
        repair.repairCost = null;
      }
      if (labourHoursEnabled && repair['labourHours'] == undefined) {
        repair.labourHours = null;
      }
    });
  }

  wo.isVisible = true;
  if (wo.changeNotes === undefined) wo.changeNotes = [];
  if (wo.datesFormatted) wo.datesFormatted = false;
  if (wo.resubmitNotes === undefined) wo.resubmitNotes = [];

  if (Array.isArray(wo.repairs)) {
    wo.repairs.forEach((repair, index) => {
      repair['itemNumber'] = index;
      repair['addRepairmanVisible'] = false;
      if (!repair.completedBy) {
        repair['completedBy'] = { date: null, id: null, name: null };
      }
      if (!Array.isArray(repair.repairedBy)) {
        repair.repairedBy = [repair.repairedBy];
      }
      repair['newRepairman'] = { name: null, id: null, date: null };
    });
  }

  // documentStatus rollup
  if (wo.repairs && wo.repairs.length > 0) {
    if (wo.repairs.find((x) => x.documentStatus === null)) {
      wo['documentStatus'] = null;
    } else if (
      wo.repairs.find((x) => x.documentStatus === true) &&
      !wo.repairs.find((x) => x.documentStatus === null)
    ) {
      wo['documentStatus'] = true;
    } else {
      wo['documentStatus'] = false;
    }
  }

  // drop deleted units
  if (Array.isArray(wo.units) && Array.isArray(units)) {
    wo.units = wo.units
      .map((unit) => units.find((x) => x.UID === unit))
      .filter((unit) => unit !== undefined)
      .map((unit) => unit.UID);
  }

  wo.view = docId;

  // convert Firestore timestamps
  if (wo.date && wo.date instanceof TS) wo.date = wo.date.toDate();
  if (wo.createdDate && wo.createdDate instanceof TS) wo.createdDate = wo.createdDate.toDate();
  if (wo.accepted && wo.accepted.time && wo.accepted.time instanceof TS) wo.accepted.time = wo.accepted.time.toDate();
  if (wo.repairsApproved && wo.repairsApproved.time && wo.repairsApproved.time instanceof TS) wo.repairsApproved.time = wo.repairsApproved.time.toDate();
  if (wo.repairsComplete && wo.repairsComplete.time && wo.repairsComplete.time instanceof TS) wo.repairsComplete.time = wo.repairsComplete.time.toDate();
  if (wo.submitted && wo.submitted.time && wo.submitted.time instanceof TS) wo.submitted.time = wo.submitted.time.toDate();
  if (wo.changeNotes && wo.changeNotes.length > 0) {
    wo.changeNotes.forEach((note) => {
      if (note.time && note.time instanceof TS) note.time = note.time.toDate();
    });
  }
  if (wo.resubmitNotes && wo.resubmitNotes.length > 0) {
    wo.resubmitNotes.forEach((note) => {
      if (note.time && note.time instanceof TS) note.time = note.time.toDate();
    });
  }
  if (wo.repairs && wo.repairs.length > 0) {
    wo.repairs.forEach((repair) => {
      if (repair.date && repair.date instanceof TS) repair.date = repair.date.toDate();
      if (repair.createdDate && repair.createdDate instanceof TS) repair.createdDate = repair.createdDate.toDate();
      if (repair.submitted && repair.submitted.time && repair.submitted.time instanceof TS) repair.submitted.time = repair.submitted.time.toDate();
      if (repair.completedBy && repair.completedBy.date && repair.completedBy.date instanceof TS) repair.completedBy.date = repair.completedBy.date.toDate();
      if (repair.repairedBy && repair.repairedBy.length > 0) {
        repair.repairedBy.forEach((repBy) => {
          if (repBy.date && repBy.date instanceof TS) repBy.date = repBy.date.toDate();
        });
      }
      if (repair.documents && repair.documents.length > 0) {
        repair.documents.forEach((d) => {
          if (d.date && d.date instanceof TS) d.date = d.date.toDate();
        });
      }
    });
  }

  return wo;
}

export function getWorkOrders(specificStartDate = null) {
  let currentDate = new Date()
  let sixMonthsAgo = new Date(currentDate);
  sixMonthsAgo.setMonth(currentDate.getMonth() - 6);
  return firebase
    .firestore()
    .collection('workOrders')
    .where('org', '==', sessionStorage.getItem('org'))
    .where('date', '>=', specificStartDate ? specificStartDate : sixMonthsAgo)
    .orderBy('date', 'desc')
    .get();
}

// every work order in the org that has no issues, regardless of date
export function getEmptyWorkOrders() {
  return firebase
    .firestore()
    .collection('workOrders')
    .where('org', '==', sessionStorage.getItem('org'))
    .where('repairs', '==', [])
    .get();
}

export async function getWorkOrdersWithConditions(unit, startDate, endDate, repairsComplete, repairsApproved) {
  endDate.setHours(23, 59, 59, 999);

  let query = firebase
    .firestore()
    .collection('workOrders')
    .where('org', '==', sessionStorage.getItem('org'))
    .where('date', '>=', startDate)
    .where('date', '<=', endDate)

  if (unit && unit.length > 0) {
    query = query.where('units', 'array-contains-any', unit);
  }

  if (repairsComplete) {
    query = query.where('repairsComplete.value', '==', repairsComplete)
  }

  if (repairsApproved) {
    query = query.where('repairsApproved.value', '==', repairsApproved)
  }

  return await query.orderBy('date', 'desc').get();
}

export async function getWorkOrderRepairsWithConditions(unit, startDate, endDate) {
  endDate.setHours(23, 59, 59, 999);

  let query = firebase
    .firestore()
    .collection('workOrderRepairs')
    .where('org', '==', sessionStorage.getItem('org'))
    .where('number', '==', null)
    .where('date', '>=', startDate)
    .where('date', '<=', endDate)

  if (unit && unit.length > 0) {
    query = query.where('units', 'array-contains-any', unit);
  }

  return await query.orderBy('date', 'desc').get();
}

export function getPositions() {
  return firebase
    .firestore()
    .collection('positions')
    .where('org', '==', sessionStorage.getItem('org'))
    .orderBy('name', 'asc')
    .get();
}

export function validateEmail(email) {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function getJobs() {
  return firebase
    .firestore()
    .collection('jobs')
    .where('org', '==', sessionStorage.getItem('org'))
    .orderBy('jobNum', 'desc')
    .get();
}

export function getSpecificJobs(field, queryOperator, comparisonValue) {
  return firebase
    .firestore()
    .collection('jobs')
    .where('org', '==', sessionStorage.getItem('org'))
    .where(field, queryOperator, comparisonValue)
    .orderBy('jobNum', 'desc')
    .get();
}

export function getJobsFromCustomer(customer) {
  return firebase
    .firestore()
    .collection('jobs')
    .where('org', '==', sessionStorage.getItem('org'))
    .where('customerDisplayName', '==', customer)
    .orderBy('jobNum', 'desc')
    .get();
}

export function getFieldTicketForm() {
  return firebase
    .firestore()
    .collection(`organizations`)
    .doc(sessionStorage.getItem('org'))
    .collection('customForms')
    .where('docName', '==', 'fieldTicket')
    .get();
}

export function getProductForm() {
  return firebase
    .firestore()
    .collection(`organizations`)
    .doc(sessionStorage.getItem('org'))
    .collection('customForms')
    .where('docName', '==', 'productForm')
    .get();
}

export function getProductsRate(product) {
  return firebase
    .firestore()
    .collection('products')
    .where('org', '==', sessionStorage.getItem('org'))
    .where('displayName', '==', product)
    .get();
}

export function getEmployeesRate(employee) {
  return firebase
    .firestore()
    .collection('employees')
    .where('org', '==', sessionStorage.getItem('org'))
    .where('displayName', '==', employee)
    .get();
}

export function getEmployeesAuth(employee) {
  return firebase
    .firestore()
    .collection('employees')
    .where('org', '==', sessionStorage.getItem('org'))
    .where('displayName', '==', employee)
    .get();
}

export function addCustomer(name, sageIntegration, qbIntegration) {
  //if the sage integration is active, then we won't do the db insert here. CAll the cloud function that will do the db insert and insert the customer into sage.
  if (sageIntegration) {
    let sendParams = {
      name: name,
      org: sessionStorage.getItem('org'),
      access_token: sessionStorage.getItem('sage_access_token'),
    };
    return axios.get(
      'http://localhost:5000/kali-45420/us-central1/addCustomerToSage',
      {
        params: {
          sendParams,
        },
      }
    );
  } else if (qbIntegration) {
    let sendParams = {
      displayName: name,
      org: sessionStorage.getItem('org'),
      access_token: sessionStorage.getItem('qb_access_token'),
      realmId: sessionStorage.getItem('qb_realmId'),
    };
    return axios.get(
      'https://us-central1-kali-45420.cloudfunctions.net/addCustomerToQB',
      {
        // return axios.get('http://localhost:5000/kali-45420/us-central1/addCustomerToQB', {
        params: {
          sendParams,
        },
      }
    );
  } else {
    return firebase
      .firestore()
      .collection('customers')
      .add({
        customerName: name.toLowerCase(),
        displayName: name,
        org: sessionStorage.getItem('org'),
      });
  }
}

export function getFieldTypes() {
  return firebase
    .firestore()
    .collection('fieldTypes')
    .orderBy('name', 'asc')
    .get();
}

export function getCompanyBillingInfo() {
  return firebase
    .firestore()
    .collection('organizations')
    .doc(sessionStorage.getItem('org'))
    .get();
}

export function getSageIntegrationDetails() {
  return firebase
    .firestore()
    .collection('organizations')
    .doc(sessionStorage.getItem('org'))
    .collection('integrations')
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        const data = doc.data();

        // ensure `sage` exists before accessing its properties
        const sage = data?.sage || {};
        sessionStorage.setItem('sage_access_token', sage.access_token ?? null);
        sessionStorage.setItem('sage_refresh_token', sage.refresh_token ?? null);
        sessionStorage.setItem('sage_active', sage.active ?? null);
        sessionStorage.setItem('sage_invoicing', sage.invoicing ?? null);
        sessionStorage.setItem('sage_customers', sage.customers ?? null);
        sessionStorage.setItem('sage_inventory', sage.inventory ?? null);
      });
    });
}

export function getCompanySettings() {
  return firebase
    .firestore()
    .collection('organizations')
    .doc(sessionStorage.getItem('org'))
    .collection('settings')
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        //update the sage details and store them in the session so we can access them for integration functionality.
        let settings = {
          work_orders: {
            repair_hours: doc.data().work_orders != undefined && doc.data().work_orders.repair_hours != undefined ? doc.data().work_orders.repair_hours : false,
            repair_cost: doc.data().work_orders != undefined && doc.data().work_orders.repair_cost != undefined ? doc.data().work_orders.repair_cost : false,
            labour_hours: doc.data().work_orders != undefined && doc.data().work_orders.labour_hours != undefined ? doc.data().work_orders.labour_hours : false,
            email_notification_enabled: doc.data().work_orders != undefined && doc.data().work_orders.email_notification_enabled != undefined ? doc.data().work_orders.email_notification_enabled : true //enabled by default
          }
        };

        store.dispatch('custom/updateCompanySettings', { settings })
      });
    });
}

export async function updateSageIntegrationDetails(
  access_token,
  refresh_token,
  invoicing,
  customers,
  inventory
) {
  let success = false;
  await firebase
    .firestore()
    .collection('organizations')
    .doc(sessionStorage.getItem('org'))
    .collection('integrations')
    .get()
    .then(async (querySnapshot) => {
      let id;
      querySnapshot.forEach((doc) => {
        //get the whole integration array and set it to a local variable, so we can edit it.
        id = doc.id;
      });
      await firebase
        .firestore()
        .collection('organizations')
        .doc(sessionStorage.getItem('org'))
        .collection('integrations')
        .doc(id)
        .update({
          sage: {
            access_token: access_token,
            refresh_token: refresh_token,
            active: true,
            invoicing: parseBoolFromString(invoicing),
            customers: parseBoolFromString(customers),
            inventory: parseBoolFromString(inventory),
          },
        })
        .then(() => {
          console.log(`Sage integration details updated.`);
          sessionStorage.setItem('sage_access_token', access_token);
          sessionStorage.setItem('sage_refresh_token', refresh_token);
          sessionStorage.setItem(
            'sage_invoicing',
            parseBoolFromString(invoicing)
          );
          sessionStorage.setItem(
            'sage_customers',
            parseBoolFromString(customers)
          );
          sessionStorage.setItem(
            'sage_inventory',
            parseBoolFromString(inventory)
          );

          success = true;
        })
        .catch((err) => {
          console.log(`Error updating Sage integration details: ${err}`);
        });
    })
    .catch((err) => {
      console.log(
        `Error getting Sage integration details before updating.: ${err}`
      );
    });
  return success;
}

export async function updateQBOIntegrationDetails(
  access_token,
  refresh_token,
  invoicing,
  customers,
  realmId,
  defaultAccountId,
  defaultAccountName
) {
  let success = true;
  console.log(`QBO integration details updated.`);
  sessionStorage.setItem('qb_access_token', access_token);
  sessionStorage.setItem('qb_refresh_token', refresh_token);
  sessionStorage.setItem('qb_invoicing', parseBoolFromString(invoicing));
  sessionStorage.setItem('qb_customers', parseBoolFromString(customers));
  sessionStorage.setItem('qb_realmId', realmId);
  sessionStorage.setItem('qb_defaultAccountId', defaultAccountId);
  sessionStorage.setItem('qb_defaultAccountName', defaultAccountName);

  return success;
}

export function getSafetyForms() {
  return firebase
    .firestore()
    .collection('organizations')
    .doc(sessionStorage.getItem('org'))
    .collection('safetyForms')
    .get();
}

export function getSafetyFormFields(form) {
  return firebase
    .firestore()
    .collection(`organizations`)
    .doc(sessionStorage.getItem('org'))
    .collection('safetyForms')
    .doc(form)
    .get();
}

//this is called after the user logs in. in the authUtils.js file.
export async function watchForIntegrationChanges() {
  firebase
    .firestore()
    .collection('organizations')
    .doc(sessionStorage.getItem('org'))
    .collection('integrations')
    .onSnapshot((docs) => {
      docs.forEach((doc) => {
        const data = doc.data();

        // ensure `sage` exists before accessing its properties
        const sage = data?.sage || {};
        sessionStorage.setItem('sage_access_token', sage.access_token ?? null);
        sessionStorage.setItem('sage_refresh_token', sage.refresh_token ?? null);
        sessionStorage.setItem('sage_active', sage.active ?? null);
        sessionStorage.setItem('sage_inventory', sage.inventory ?? null);
        sessionStorage.setItem('sage_customers', sage.customers ?? null);
        sessionStorage.setItem('sage_invoicing', sage.invoicing ?? null);
        sessionStorage.setItem('sage_authorized', sage.authorized ?? null);

        // ensure `quick_books` exists before accessing its properties
        const quickBooks = data?.quick_books || {};
        sessionStorage.setItem('qb_access_token', quickBooks.access_token ?? null);
        sessionStorage.setItem('qb_refresh_token', quickBooks.refresh_token ?? null);
        sessionStorage.setItem('qb_active', quickBooks.active ?? null);
        sessionStorage.setItem('qb_customers', quickBooks.customers ?? null);
        sessionStorage.setItem('qb_invoicing', quickBooks.invoicing ?? null);
        sessionStorage.setItem('qb_realmId', quickBooks.realmId ?? null);
        sessionStorage.setItem('qb_authorized', quickBooks.authorized ?? null);
        sessionStorage.setItem(
          'qb_defaultAccountId',
          quickBooks.defaultAccount?.id ?? null
        );
        sessionStorage.setItem(
          'qb_defaultAccountName',
          quickBooks.defaultAccount?.name ?? null
        );

        // ensure `tikker` exists before accessing its properties
        const tikker = data?.tikker || {};
        sessionStorage.setItem('tikker_authorized', tikker.authorized ?? null);
      });
    });
}

export async function syncQBCustomers() {
  let sendParams = {
    access_token: `${sessionStorage.getItem('qb_access_token')}`,
    refresh_token: `${sessionStorage.getItem('qb_refresh_token')}`,
    realmId: `${sessionStorage.getItem('qb_realmId')}`,
    org: sessionStorage.getItem('org'),
  };
  return axios.get(
    `https://us-central1-kali-45420.cloudfunctions.net/getQBCustomers`,
    {
      //return axios.get(`http://localhost:5000/kali-45420/us-central1/getQBCustomers`, {
      params: {
        sendParams,
      },
    }
  );
}

export async function getQBIncomeAccounts() {
  let sendParams = {
    access_token: `${sessionStorage.getItem('qb_access_token')}`,
    refresh_token: `${sessionStorage.getItem('qb_refresh_token')}`,
    realmId: `${sessionStorage.getItem('qb_realmId')}`,
    org: sessionStorage.getItem('org'),
  };
  return axios.get(
    `https://us-central1-kali-45420.cloudfunctions.net/getQBIncomeAccounts`,
    {
      // return axios.get(`http://localhost:5000/kali-45420/us-central1/getQBIncomeAccounts`, {
      params: {
        sendParams,
      },
    }
  );
}

export function getCompanyCollections() {
  return firebase
    .firestore()
    .collection('customCollections')
    .where('org', '==', sessionStorage.getItem('org'))
    .orderBy('name', 'asc')
    .get();
}

export function getCustomCollectionData(collection) {
  return firebase
    .firestore()
    .collection('customCollections')
    .doc(collection.id)
    .get();
}

export function getCustomCollectionDataFromName(collection) {
  return firebase
    .firestore()
    .collection('customCollections')
    .where('name', '==', collection)
    .get();
}

export function addCustomCollectionItem(collection, items) {
  return firebase
    .firestore()
    .collection('customCollections')
    .doc(collection.id)
    .update({
      values: items,
    });
}

export function addCustomCollection(name) {
  return firebase
    .firestore()
    .collection('customCollections')
    .add({
      name: name,
      org: sessionStorage.getItem('org'),
    });
}

export function deleteCustomCellection(doc) {
  return firebase
    .firestore()
    .collection('customCollections')
    .doc(doc)
    .delete();
}

export function checkForDuplicateCollection(name) {
  return firebase
    .firestore()
    .collection('customCollections')
    .where('org', '==', sessionStorage.getItem('org'))
    .where('name', '==', name)
    .limit(1)
    .get();
}

export function getInvoiceTemplate(templateName) {
  return firebase
    .firestore()
    .collection('organizations')
    .doc(sessionStorage.getItem('org'))
    .collection('invoiceTemplates')
    .where('docName', '==', templateName)
    .get();
}

// Work Order Editing Status Management Functions
export function setWorkOrderEditingStatus(workOrderId, userInfo) {
  return firebase
    .firestore()
    .collection('workOrders')
    .doc(workOrderId)
    .update({
      currentlyEditedBy: {
        uid: userInfo.uid,
        name: userInfo.displayName,
        email: userInfo.email,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        hasUnsavedChanges: false
      }
    });
}

// flags whether the user holding the editing lock has typed changes they have not saved yet
export function updateWorkOrderUnsavedChangesStatus(workOrderId, hasUnsavedChanges) {
  return firebase
    .firestore()
    .collection('workOrders')
    .doc(workOrderId)
    .update({
      'currentlyEditedBy.hasUnsavedChanges': !!hasUnsavedChanges
    })
    .catch((error) => {
      console.error('Error updating work order unsaved changes status:', error);
    });
}

export function clearWorkOrderEditingStatus(workOrderId) {
  return firebase
    .firestore()
    .collection('workOrders')
    .doc(workOrderId)
    .update({
      currentlyEditedBy: firebase.firestore.FieldValue.delete()
    });
}

export function checkWorkOrderEditingStatus(workOrderId) {
  return firebase
    .firestore()
    .collection('workOrders')
    .doc(workOrderId)
    .get()
    .then((doc) => {
      if (!doc.exists) {
        return { isBeingEdited: false, editedBy: null, hasUnsavedChanges: false };
      }

      const data = doc.data();
      const currentlyEditedBy = data.currentlyEditedBy;

      if (!currentlyEditedBy || !currentlyEditedBy.timestamp) {
        return { isBeingEdited: false, editedBy: null, hasUnsavedChanges: false };
      }

      // if the currentlyEditedBy timestamp is older than 1 minute, consider it stale and not being edited
      const lastUpdated = currentlyEditedBy.timestamp.toDate();
      const now = new Date();
      const diffMs = now - lastUpdated;
      const diffMinutes = diffMs / 1000 / 60;

      if (diffMinutes > 1) {
        return { isBeingEdited: false, editedBy: null, hasUnsavedChanges: false };
      }

      return {
        isBeingEdited: !!currentlyEditedBy,
        editedBy: currentlyEditedBy,
        hasUnsavedChanges: !!currentlyEditedBy.hasUnsavedChanges
      };
    });
}

export function clearWorkOrderBeingEditedByUser(uid) {
  const db = firebase.firestore();
  const { FieldValue } = firebase.firestore;

  return db
    .collection('workOrders')
    .where('currentlyEditedBy.uid', '==', uid)
    .limit(1) 
    .get()
    .then((querySnapshot) => {
      if (querySnapshot.empty) {
        return false;
      }

      const doc = querySnapshot.docs[0];
      return db
        .collection('workOrders')
        .doc(doc.id)
        .update({
          currentlyEditedBy: FieldValue.delete(),
        })
        .then(() => (true));
    })
    .catch((error) => {
      console.error("Error clearing editing status: ", error);
    });
}

export function updateWorkOrderBeingEditedTimestamp(workOrderId, hasUnsavedChanges) {
  const db = firebase.firestore();
  const { FieldValue } = firebase.firestore;

  const updates = { 'currentlyEditedBy.timestamp': FieldValue.serverTimestamp() };

  if (typeof hasUnsavedChanges === 'boolean') {
    updates['currentlyEditedBy.hasUnsavedChanges'] = hasUnsavedChanges;
  }

  db
    .collection('workOrders')
    .doc(workOrderId)
    .update(updates)
    .catch((error) => {
      console.error("Error updating work order timestamp:", error);
    });
}





